// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip__tooltip","tt":"Tooltip__tt","tooltipSVG":"Tooltip__tooltipSVG","tooltipText":"Tooltip__tooltipText","outline":"Tooltip__outline"};